export default "__VITE_ASSET__CrdQ5axy__"